export const HOLIDAY_GLYPHS = [
  {value:"pumpkin",label:"Pumpkin"}, {value:"christmas_tree",label:"Christmas tree"}, {value:"party_popper",label:"Party popper"},
];
export const dayClosure = (version,date) => (version?.eg_day_closures || []).find(item=>item.date===date);
export const openDayShifts = version => (version?.eg_shifts || []).filter(shift=>!dayClosure(version,shift.date));
export const closureGlyph = value => HOLIDAY_GLYPHS.some(item=>item.value===value) ? value : "pumpkin";
